export default function isValidException(err) {
  if (!err) return false;
  // Check if instance of error
  if (err instanceof Error) {
    return true;
  }

  // Some errors may not confirm to an instance but still include required error properties to be handled as exception (iframes/cross frame etc)
  return (err.stack && err.message && typeof err.stack === 'string') || false;
}



// WEBPACK FOOTER //
// ./utils/isValidException.jsx